import { render, staticRenderFns } from "./ThirdFrame.vue?vue&type=template&id=161c2ed0&scoped=true&"
import script from "./ThirdFrame.vue?vue&type=script&lang=js&"
export * from "./ThirdFrame.vue?vue&type=script&lang=js&"
import style0 from "./ThirdFrame.vue?vue&type=style&index=0&id=161c2ed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c2ed0",
  null
  
)

export default component.exports